/**
 * The `state` payload carried through the Keycloak round-trip, so the callback
 * can land the user back where they started instead of on the home page.
 */
export interface SigninState {
  returnTo?: string;
}

export function makeSigninState(returnTo: string): SigninState {
  return { returnTo };
}

/**
 * The state comes back from the authorization server via the browser, so it is
 * untrusted input: accept only an in-app path (a single leading slash — `//`
 * would be a protocol-relative external URL) and fall back to home.
 */
export function readReturnTo(state: unknown): string {
  if (
    typeof state === 'object' &&
    state !== null &&
    'returnTo' in state &&
    typeof state.returnTo === 'string' &&
    state.returnTo.startsWith('/') &&
    !state.returnTo.startsWith('//')
  ) {
    return state.returnTo;
  }
  return '/';
}
